module.exports = "<p>\r\n  services works!\r\n</p>\r\n<app-circular></app-circular>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/services/services.component.html
// module id = ../../../../../src/app/_components/services/services.component.html
// module chunks = 1